import { Button } from '@crazyegginc/hatch';

import { Modal } from '/src/contexts/modal';
import { WebP } from '/src/components/WebP';
import { UpsellWall } from '/src/components/UpsellWall';
import { AppLink } from '/src/features/_global/components/AppLink';
import { useManageSubscriptionPath } from '/src/hooks';

import GoalsPNG from '@crazyegginc/hatch/dist/images/illustration-goal-target.png';
import GoalsWebP from '@crazyegginc/hatch/dist/images/illustration-goal-target.webp';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';

const TEXT_LIST = [
  {
    text: 'Analyze conversion rates and conversion value for A/B Testing',
  },
  {
    text: 'Drive more on-site conversions with smart CTAs',
  },
  {
    text: 'Filter Heatmaps based on conversion events',
  },
];

export function GoalUpsellModal({ onBack }) {
  const manageSubscriptionPath = useManageSubscriptionPath();

  return (
    <Modal
      dialogClassName="!w-[640px] !px-2"
      dismissable={onBack ? false : true}
      disableOutsideClick={onBack ? true : false}
    >
      <div className="flex items-center">
        <div className="mx-4 flex items-center shrink-0">
          <WebP webp={GoalsWebP} fallback={GoalsPNG} width="190px" height="163px" alt="goals feature" />
        </div>
        <div>
          <h2 className="text-header-1 font-semibold">Measure conversion events that you want to drive</h2>
          <div className="text-body-2 my-6">
            Configure on-site actions that you find valuable: link clicks, page views, form submissions, ad conversion
            pixels, or a javascript code snippet.
          </div>
          <UpsellWall.List list={TEXT_LIST} />
          <div className="w-full flex mt-1 space-x-2.5">
            {onBack ? (
              <Button variant="cancel" onClick={onBack}>
                <ArrowIcon className="mr-2 h-2.5 w-2.5 -rotate-90 fill-current" />
                Go Back
              </Button>
            ) : null}
            <Button component={AppLink} to={manageSubscriptionPath} target="_blank" rel="noopener noreferrer">
              View Plans
            </Button>
          </div>
        </div>
      </div>
      {onBack ? (
        <Button variant="cancel" onClick={onBack} className="absolute top-2 left-2">
          <ArrowIcon className="mr-2 h-2.5 w-2.5 -rotate-90 fill-current" />
          Back
        </Button>
      ) : null}
    </Modal>
  );
}
